export default "__VITE_ASSET__X46KmQUp__"